import { render, staticRenderFns } from "./ManageIncidentForm.vue?vue&type=template&id=cc5d550c&scoped=true"
import script from "./ManageIncidentForm.vue?vue&type=script&lang=js"
export * from "./ManageIncidentForm.vue?vue&type=script&lang=js"
import style0 from "./ManageIncidentForm.vue?vue&type=style&index=0&id=cc5d550c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5d550c",
  null
  
)

export default component.exports